import { authorizedAPI } from "@/config/axios.config";
import { UtilsService } from "../utils";

const utils = new UtilsService();

export interface FormTemplate {
  id: string;
  name: string;
  description?: string;
  category?: string;
  design: any;
  createdAt: string;
  updatedAt: string;
}

export interface ProcessTemplate {
  id: string;
  name: string;
  description?: string;
  category?: string;
  type: string;
  staffViewForms: boolean;
  applicantViewProcessLevel: boolean;
  steps: any[];
  createdAt: string;
  updatedAt: string;
}

export interface PublishFormTemplateDto {
  formId: string;
  description?: string;
  category?: string;
}

export interface PublishProcessTemplateDto {
  processId: string;
  description?: string;
  category?: string;
}

export interface UseFormTemplateDto {
  creatorId: string;
  folderId?: string;
  name?: string;
}

export interface UseProcessTemplateDto {
  creatorId: string;
  groupId: string;
  processFolderId?: string;
  name?: string;
}

class TemplateService {
  async getAllFormTemplates(): Promise<FormTemplate[]> {
    return utils.handleApiRequest(() =>
      authorizedAPI.get("/consumer/templates/forms"),
    );
  }

  async getFormTemplateById(id: string): Promise<FormTemplate> {
    return utils.handleApiRequest(() =>
      authorizedAPI.get(`/consumer/templates/forms/${id}`),
    );
  }

  async getAllProcessTemplates(): Promise<ProcessTemplate[]> {
    return utils.handleApiRequest(() =>
      authorizedAPI.get("/consumer/templates/processes"),
    );
  }

  async getProcessTemplateById(id: string): Promise<ProcessTemplate> {
    return utils.handleApiRequest(() =>
      authorizedAPI.get(`/consumer/templates/processes/${id}`),
    );
  }

  async useFormTemplate(id: string, data: UseFormTemplateDto) {
    return utils.handleApiRequest(() =>
      authorizedAPI.post(`/consumer/templates/forms/${id}/use`, data),
    );
  }

  async useProcessTemplate(id: string, data: UseProcessTemplateDto) {
    return utils.handleApiRequest(() =>
      authorizedAPI.post(`/consumer/templates/processes/${id}/use`, data),
    );
  }

  async publishFormTemplate(data: PublishFormTemplateDto): Promise<FormTemplate> {
    return utils.handleApiRequest(() =>
      authorizedAPI.post("/templates/forms/publish", data),
    );
  }

  async publishProcessTemplate(data: PublishProcessTemplateDto): Promise<ProcessTemplate> {
    return utils.handleApiRequest(() =>
      authorizedAPI.post("/templates/processes/publish", data),
    );
  }

  async deleteFormTemplate(id: string): Promise<void> {
    return utils.handleApiRequest(() =>
      authorizedAPI.delete(`/templates/forms/${id}`),
    );
  }

  async deleteProcessTemplate(id: string): Promise<void> {
    return utils.handleApiRequest(() =>
      authorizedAPI.delete(`/templates/processes/${id}`),
    );
  }
}

export const templateService = new TemplateService();
